import React, { ReactNode, createContext, useContext } from 'react';
import { IStepperFormData, IStepperState, useStepperState } from './hooks';

interface IStepperContextProps {
    children: ReactNode;
    initialData?: Partial<IStepperFormData>;
}

const StepperContext = createContext<IStepperState | null>(null);

export const StepperProvider: React.FC<IStepperContextProps> = ({ children, initialData }) => {
    const stepperState = useStepperState(initialData);

    return <StepperContext.Provider value={stepperState}>{children}</StepperContext.Provider>;
};

export const useStepperContext = (): IStepperState => {
    const context = useContext(StepperContext);
    if (!context) {
        throw new Error('useStepperContext must be used within a StepperProvider');
    }
    return context;
};
